/* eslint-disable react/no-unused-state */
import PropTypes from 'prop-types';
import React from 'react';
import { FloatingInput } from '@piplapps/pipl-ui';

import { Col, FormControl, FormGroup, Row } from 'react-bootstrap/lib/';
import { isEmail, isURL } from 'validator';
import { COUNTRIES, STATES_BY_COUNTRY } from 'Constants/Common';
import './OnboardingUpdateOrganizationDetailsForm.less';
import { getInputValue } from '../../utils';

// import FloatingInput from '../FloatingInput/FloatingInput'

class OrganizationDetailsForm extends React.Component {
  // eslint-disable-next-line react/static-property-placement
  static propTypes = {
    onSubmit: PropTypes.func,
    isSubmittingForm: PropTypes.bool,
    serverErrorByField: PropTypes.object,
    user: PropTypes.object,
    updatedState: PropTypes.func,
  };

  constructor(props) {
    super(props);
    // eslint-disable-next-line react/state-in-constructor
    this.state = {
      form: {
        country: null,
      },
      name: {
        validationState: null,
        help: null,
      },
      invoice_email: {
        validationState: this.props.user ? 'success' : null,
        help: null,
      },
      website: {
        validationState: null,
        help: null,
      },
      phone: {
        validationState: null,
        help: null,
      },
      promo_code: {
        validationState: null,
        help: null,
      },
      city: {
        validationState: null,
        help: null,
      },
      state: {
        validationState: null,
        help: null,
      },
      country: {
        validationState: null,
        help: null,
      },
      address: {
        validationState: null,
        help: null,
      },
      postalCode: {
        validationState: null,
        help: null,
      },
      show: false,
    };
  }

  _isServerError = (prevProps, curProps) => {
    return !prevProps.serverErrorByField && curProps.serverErrorByField && curProps.serverErrorByField.address;
  };

  _isFormValid = () => {
    const requiredValidations = ['name', 'city', 'state', 'country', 'address', 'postalCode'];
    return requiredValidations.every((validation) => this.state[validation].validationState);
  };

  componentDidUpdate(prevProps) {
    if (this._isServerError(prevProps, this.props)) {
      this._invalidAddressFields();
    }
    this.props.updatedState(this._isFormValid());
  }

  cleanValidation() {
    this.setState({
      name: {
        validationState: null,
        help: null,
      },
      invoice_email: {
        validationState: null,
        help: null,
      },
      website: {
        validationState: null,
        help: null,
      },
      phone: {
        validationState: null,
        help: null,
      },
      promo_code: {
        validationState: null,
        help: null,
      },
      city: {
        validationState: null,
        help: null,
      },
      state: {
        validationState: null,
        help: null,
      },
      country: {
        validationState: null,
        help: null,
      },
      address: {
        validationState: null,
        help: null,
      },
      postalCode: {
        validationState: null,
        help: null,
      },
    });
  }

  isValidOrgAddress() {
    const country = getInputValue(this._country);
    const stateVal = this._stateInput ? getInputValue(this._stateInput) : null;
    const city = getInputValue(this._city);
    const address = getInputValue(this._address);
    const postalCode = getInputValue(this._postalCode);
    return (
      country &&
      city &&
      address &&
      postalCode &&
      (((country === 'US' || country === 'CA') && stateVal) || (country !== 'US' && country !== 'CA'))
    );
  }

  _validAddressFields() {
    this.setState({
      country: {
        validationState: 'success',
      },
      state: {
        validationState: 'success',
      },
      city: {
        validationState: 'success',
      },
      address: {
        validationState: 'success',
      },
      postalCode: {
        validationState: 'success',
      },
    });
  }

  _invalidAddressFields() {
    this.setState({
      country: {
        validationState: 'error',
        help: '',
      },
      state: {
        validationState: 'error',
        help: '',
      },
      city: {
        validationState: 'error',
        help: '',
      },
      address: {
        validationState: 'error',
        help: '',
      },
      postalCode: {
        validationState: 'error',
        help: '',
      },
    });
  }

  _updateAddressValidation() {
    if (this.isValidOrgAddress()) {
      this._validAddressFields();
    }
  }

  isValidTaxAddress(isSubmittingForm = false) {
    // In case we are submitting the form or sales tax enabled
    if (isSubmittingForm) {
      return true;
    }
    return typeof this.props.serverErrorByField !== 'undefined';
  }

  validateCountryState() {
    const country = getInputValue(this._country);
    const stateVal = this._stateInput ? getInputValue(this._stateInput) : null;

    if (country) {
      if (this.isValidCountryState()) {
        this.setState({
          state: { validationState: 'success', help: null },
          country: { validationState: 'success', help: null },
        });
      } else if (country === 'US' || country === 'CA') {
        this.setState({
          state: {
            validationState: 'error',
            help: gettext('State is required'),
          },
          country: { validationState: null, help: null },
        });
      } else if (stateVal) {
        this.setState({
          state: {
            validationState: 'error',
            help: gettext('Not in this country'),
          },
          country: { validationState: null, help: null },
        });
      }
      this.setState({ form: { country } });
    } else {
      this.setState({
        country: {
          validationState: 'error',
          help: gettext('Country is required'),
        },
        state: { validationState: null, help: null },
      });
    }
  }

  validateRequired(field) {
    const value = getInputValue(this[`_${field}`]);
    const newState = {};

    newState[field] =
      value.length > 0
        ? { validationState: 'success', help: null }
        : {
            validationState: 'error',
            help: 'Field is required',
          };

    this.setState(newState);
  }

  validateEmail() {
    if (this.isValidEmail(this._invoice_email)) {
      if (getInputValue(this._invoice_email).length > 0) {
        this.setState({ invoice_email: { validationState: 'success' } });
      }
    } else {
      this.setState({
        invoice_email: {
          validationState: 'error',
          help: 'Invalid email',
        },
      });
    }
  }

  validatePhone() {
    if (OrganizationDetailsForm.isValidPhoneNumber(this._phone)) {
      if (getInputValue(this._phone).length > 0) {
        this.setState({ phone: { validationState: 'success' } });
      }
    } else {
      this.setState({
        phone: {
          validationState: 'error',
          help: 'Invalid phone',
        },
      });
    }
  }

  validateWebsite() {
    if (OrganizationDetailsForm.isValidURL(this._website)) {
      if (getInputValue(this._website).length > 0) {
        this.setState({ website: { validationState: 'success' } });
      }
    } else {
      this.setState({
        website: {
          validationState: 'error',
          help: 'Invalid website address',
        },
      });
    }
  }

  validateForm() {
    if (!this.isFormValid()) {
      this.validateRequired('name');
      this.validateRequired('invoice_email');
      this.validateEmail();
      this.validateWebsite();
      this.validatePhone();
      if (this.isValidTaxAddress()) {
        this.validateRequired('city');
        this.validateRequired('address');
        this.validateRequired('postalCode');
        this.validateCountryState();
      } else {
        this._updateAddressValidation();
      }

      return false;
    }
    return true;
  }

  isValidCountryState() {
    const country = getInputValue(this._country);
    const state = this._stateInput ? getInputValue(this._stateInput) : null;

    if (country.length === 0) {
      return false;
    }
    if (country === 'US' || country === 'CA') {
      const validStates = STATES_BY_COUNTRY[country];
      return validStates.findIndex((st) => st[0] === state) > -1;
    }
    return true;
  }

  isValidEmail(field) {
    const value = getInputValue(field);

    return value.length === 0 || isEmail(value);
  }

  static isValidURL(field) {
    const value = getInputValue(field);
    return value.length === 0 || isURL(value);
  }

  static isValidPhoneNumber(field) {
    const value = getInputValue(field);

    return value.length === 0 || /^[- +()]*[0-9][- +()0-9]*$/.test(value);
  }

  isNameValid() {
    return getInputValue(this._name).length > 0;
  }

  isFormValid() {
    return (
      this.isNameValid() &&
      this.isValidEmail(this._invoice_email) &&
      OrganizationDetailsForm.isValidURL(this._website) &&
      OrganizationDetailsForm.isValidPhoneNumber(this._phone) &&
      this.isValidCountryState() &&
      this.isValidOrgAddress() &&
      this.isValidTaxAddress(true)
    );
  }

  submit() {
    if (this.validateForm()) {
      const name = getInputValue(this._name);
      const address = getInputValue(this._address);
      const city = getInputValue(this._city);
      const country = getInputValue(this._country);
      const state = this._stateInput ? getInputValue(this._stateInput) : null;
      const postalCode = getInputValue(this._postalCode);
      const website = getInputValue(this._website);
      const invoiceEmail = getInputValue(this._invoice_email);
      const phone = getInputValue(this._phone);

      this.cleanValidation();
      this.props.onSubmit(name, invoiceEmail, website, phone, address, city, country, state, postalCode);
    }
  }

  _dummy = () => {
    this.setState({ ...this.state }); //eslint-disable-line
  };

  render() {
    const orgState = this.state;
    const { country } = orgState.form;

    return (
      <div className="c-organization-details-form">
        <div className="c-organization-details-form__cc">
          <form>
            <Row>
              <Col xs={12}>
                <FormGroup bsSize="small" test-id="organization_name" validationState={orgState.name.validationState}>
                  <FloatingInput
                    placeholder={gettext('Organization name')}
                    name="name"
                    value={getInputValue(this._name)}
                    forcedError={orgState.name.help}
                    renderInput={() => {
                      return (
                        <FormControl
                          onChange={this._dummy}
                          type="text"
                          test-id="organization_name_input"
                          ref={(input) => (this._name = input)} //eslint-disable-line
                          onBlur={this.validateRequired.bind(this, 'name')} //eslint-disable-line
                        />
                      );
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={12} xs={12}>
                <FormGroup
                  bsSize="small"
                  test-id="organization_email"
                  validationState={orgState.invoice_email.validationState}
                >
                  <FloatingInput
                    placeholder={gettext('Invoice email')}
                    name="organization_email"
                    defaul
                    value={getInputValue(this._invoice_email)}
                    forcedError={orgState.invoice_email.help}
                    renderInput={() => {
                      return (
                        <FormControl
                          onChange={this._dummy}
                          type="text"
                          test-id="organization_email_input"
                          value={getInputValue(this._invoice_email) || this.props.user?.email}
                          ref={(input) => (this._invoice_email = input)} //eslint-disable-line
                          onBlur={() => {
                            this.validateRequired.bind(this, 'invoice_email');
                            this.validateEmail();
                          }} //eslint-disable-line
                        />
                      );
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm={12} xs={12}>
                <FormGroup
                  bsSize="small"
                  test-id="organization_website"
                  validationState={orgState.website.validationState}
                >
                  <FloatingInput
                    placeholder={gettext('Website')}
                    name="organization_website"
                    value={getInputValue(this._website)}
                    forcedError={orgState.website.help}
                    renderInput={() => {
                      return (
                        <FormControl
                          onChange={this._dummy}
                          type="text"
                          test-id="organization_website_input"
                          ref={(input) => (this._website = input)} //eslint-disable-line
                          onBlur={() => this.validateWebsite()} //eslint-disable-line
                        />
                      );
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <FormGroup bsSize="small" test-id="organization_phone" validationState={orgState.phone.validationState}>
                  <FloatingInput
                    placeholder={gettext('Phone')}
                    name="organization_website"
                    value={getInputValue(this._phone)}
                    forcedError={orgState.phone.help}
                    renderInput={() => {
                      return (
                        <FormControl
                          onChange={this._dummy}
                          type="text"
                          test-id="organization_phone_input"
                          ref={(input) => (this._phone = input)} //eslint-disable-line
                          onBlur={() => this.validatePhone()} //eslint-disable-line
                        />
                      );
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <FormGroup
                  bsSize="small"
                  test-id="organization_address"
                  validationState={orgState.address.validationState}
                >
                  <FloatingInput
                    placeholder={gettext('Billing address')}
                    name="organization_address"
                    value={getInputValue(this._address)}
                    forcedError={orgState.address.help}
                    renderInput={() => {
                      return (
                        <FormControl
                          onChange={this._dummy}
                          type="text"
                          test-id="organization_address_input"
                          ref={(input) => (this._address = input)} //eslint-disable-line
                          onBlur={() => {
                            this.validateRequired('address');
                            // this.validateAddress();
                          }} //eslint-disable-line
                        />
                      );
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <FormGroup
                  bsSize="small"
                  test-id="organization_country"
                  validationState={orgState.country.validationState}
                >
                  <FloatingInput
                    name="organization_country"
                    value={getInputValue(this._address)}
                    forcedError={orgState.country.help}
                    renderInput={() => {
                      return (
                        <FormControl
                          test-id="organization_country_select"
                          type="text"
                          ref={(input) => (this._country = input)} //eslint-disable-line
                          componentClass="select"
                          onChange={() => {
                            this.validateCountryState();
                            // this.validateAddress();
                          }}
                        >
                          <option value="">{gettext('Country')}</option>
                          {COUNTRIES.map((x) => (
                            <option key={x[0]} value={x[0]}>
                              {x[1]}
                            </option>
                          ))}
                        </FormControl>
                      );
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              {country === 'US' || country === 'CA' ? (
                <Col xs={12}>
                  <FormGroup
                    bsSize="small"
                    test-id="organization_state"
                    validationState={orgState.state.validationState}
                  >
                    <FloatingInput
                      // placeholder={gettext('Country')}
                      name="organization_state"
                      value={getInputValue(this._stateInput)}
                      forcedError={orgState.state.help}
                      renderInput={() => {
                        return (
                          <FormControl
                            type="text"
                            test-id="organization_state_input"
                            ref={(input) => (this._stateInput = input)} //eslint-disable-line
                            componentClass="select"
                            onChange={() => {
                              this.validateCountryState();
                              // this.validateAddress();
                            }}
                          >
                            <option value="">{country === 'CA' ? gettext('Province') : gettext('State')}</option>
                            {STATES_BY_COUNTRY[country].map((x) => (
                              <option key={x[0]} value={x[0]}>
                                {x[1]}
                              </option>
                            ))}
                          </FormControl>
                        );
                      }}
                    />
                  </FormGroup>
                </Col>
              ) : null}
            </Row>
            <Row>
              <Col xs={12}>
                <FormGroup bsSize="small" test-id="organization_city" validationState={orgState.city.validationState}>
                  <FloatingInput
                    placeholder={gettext('City')}
                    name="organization_city"
                    value={getInputValue(this._city)}
                    forcedError={orgState.city.help}
                    renderInput={() => {
                      return (
                        <FormControl
                          onChange={this._dummy}
                          type="text"
                          test-id="organization_city_input"
                          ref={(input) => (this._city = input)} //eslint-disable-line
                          onBlur={() => {
                            this.validateRequired('city');
                            // this.validateAddress();
                          }} //eslint-disable-line
                        />
                      );
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <FormGroup
                  bsSize="small"
                  test-id="organization_zip"
                  validationState={orgState.postalCode.validationState}
                >
                  <FloatingInput
                    placeholder={gettext('Postal code')}
                    name="organization_zip"
                    value={getInputValue(this._postalCode)}
                    forcedError={orgState.postalCode.help}
                    renderInput={() => {
                      return (
                        <FormControl
                          onChange={this._dummy}
                          type="text"
                          test-id="organization_zip_input"
                          ref={(input) => (this._postalCode = input)} //eslint-disable-line
                          onBlur={() => {
                            this.validateRequired('postalCode');
                            // this.validateAddress();
                          }} //eslint-disable-line
                        />
                      );
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
          </form>
        </div>
      </div>
    );
  }
}

export default OrganizationDetailsForm;
